
import styled from 'styled-components'

const Container = styled.div`
    margin: 5em 0;
`
const Column = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    @media (max-width:1050px){
        display: flex;
        flex-direction: column;
        img{
            margin: 2em auto;
            width: 90%;
        }
    }
`
const Row = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 5em;
    justify-content: center;
    *{
        margin: .5em 0;
    }
    @media (max-width:600px){
        margin: 0 1em;
    }
`
const Button = styled.button`
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;

    display: flex;
    align-items: center;
    
    padding: 10px 15px;
    border-radius: 5px;
    width:250px;
    margin:1em 0;
    
    background: white;
    color: var(--bg-primary);
    border: 3px solid var(--bg-primary);
    &:hover{
        background: var(--bg-primary);
        color: white;
        border: 3px solid transparent;
        cursor: pointer;
        user-select: none;
        
        .right-arrow{
            border-top: 2px solid #FFF;
            border-left: 2px solid #FFF;
            &::after{
                background-color: #FFF;
            }
        }
    }
    .right-arrow{
        display: block;
        margin: 15px auto;
        width: 10px;
        height: 10px;
        border-top: 2px solid var(--bg-primary);
        border-left: 2px solid var(--bg-primary);
        transform: rotate(135deg);
        &::after{
            content: "";
            display: block;
            width: 2px;
            height: 20px;
            background-color: var(--bg-primary);
            transform: rotate(-45deg) translate(6px, 1px);
            left: 0;
            top: 0;
        }
    }
    @media (max-width:600px){
        /* width: 100%; */
    }
`
const Highlight = styled.p`
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    /* identical to box height, or 34px */

    color: var(--bg-primary);
`
const Label = styled.h2`
    width: 748px;
    @media (max-width:1500px){
        width: 100%;
    }
`
function Community (props) {
  const { contents } = props
  return (
        <Container>
            <Column>
                {/* <img src="/media/hero/community.png" alt="Community" /> */}
                <img src="/media/hero/community.png" style={{width: '508px', padding: '0 5px'}} alt="Community" />
                <Row>
                    <Highlight>{contents.homeContactHighlight}</Highlight>
                    <Label>{contents.homeContactLabel}</Label>
                    <p> {contents.homeContactCaption} </p>
                    <Button inverted onClick={() => { window.location.href = '/landing/contact' }} style={{}}>
                        Customer Service <span className="right-arrow" />
                    </Button>
                </Row>
            </Column>
        </Container>
  )
}

export default Community
